import { Outlet } from "react-router-dom";
import { useContext } from "react";
import AuthContext from "../../context/authProvider";
import SideNav from "./SideNav";

const LINKS = [
    { to: "/partner", label: "Início", end: true },
    { to: "/partner/products", label: "Pedidos" },
    { to: "/partner/status", label: "Fluxos Status" },
];

const PartnerLayout = () => {
    const { user, logout } = useContext(AuthContext);

    return (
        <div className="flex min-h-screen text-orange-100">
            <SideNav home="/partner" links={LINKS} user={user} onLogout={logout} />
            <div className="min-w-0 flex-1"><Outlet /></div>
        </div>
    );
};

export default PartnerLayout;
